/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

// Import from application
import InCourseSearchBar from 'bundles/in-course-search/components/SearchBar';

const styles = {
  searchBarContainer: css`
    max-width: 361px;
    min-width: 0;
    width: 100%;

    & div {
      min-width: 0;
    }
  `,
  styleFixes: css`
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }
  `,
};

const InCourseSearchGridItem = ({ referrer, isInternal }: { referrer?: string; isInternal?: boolean }) => {
  return (
    <div css={[styles.searchBarContainer, styles.styleFixes]}>
      <InCourseSearchBar referrer={referrer} isInternal={isInternal} />
    </div>
  );
};

export default InCourseSearchGridItem;
